import type { SensorView } from '@mark43/cad-api';
import { useDispatchAreaStore } from '../dispatch-areas/use-dispatch-areas';
import { getSensorDispatchAreaName } from './helpers';

/**
 * The name of the dispatch area a camera sits in, from the dispatch area store — which holds every
 * area in the department, since bootstrap asks for all of them — so this costs no request. The
 * store is observable: call this from an `observer` component.
 */
export function useSensorDispatchAreaName(
    sensor: Pick<SensorView, 'classification'> | undefined
): string | undefined {
    const dispatchAreaStore = useDispatchAreaStore();
    return getSensorDispatchAreaName(sensor, dispatchAreaStore.allDispatchAreaObjects);
}
